import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TileComponent } from './tile.component';

@NgModule({
  imports: [CommonModule],
  exports: [TileComponent],
  declarations: [TileComponent],
  providers: [],
})
export class AccredibleTileComponentModule {}
